var _defs, _sodipodiNamedview;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntroToSolids({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 126.40613,
    height: 126.406,
    viewBox: "0 0 126.40613 126.406",
    sodipodidocname: "Intro to solids.ai",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,94.805 H 94.805 V 0 H 0 Z",
    id: "path14"
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapepageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapegroupmode: "layer",
    inkscapelabel: "Intro to solids",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,126.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    clipPath: "url(#clipPath16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(86.8273,65.8809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.222,-1.436 -0.989,-2.698 -2.158,-3.554 l -0.204,-0.149 -0.226,-0.113 -0.817,-0.409 c -4.021,-2.01 -7.754,-4.553 -11.098,-7.558 l -2.657,-2.389 c -0.231,-3.196 -2.161,-6.482 -5.226,-8.725 -2.306,-1.688 -4.998,-2.617 -7.58,-2.617 -2.889,0 -5.417,1.191 -6.936,3.267 -0.724,0.988 -1.171,2.096 -1.373,3.259 -0.311,-0.38 -0.625,-0.758 -0.976,-1.125 -0.198,-0.205 -0.22,-0.298 -0.139,-0.583 1.647,-5.802 2.724,-11.096 3.293,-16.184 0.525,-4.699 -0.417,-8.449 -2.878,-11.465 -1.778,-2.179 -4.313,-3.62 -7.534,-4.283 -0.95,-0.196 -1.926,-0.273 -2.869,-0.348 -0.423,-0.033 -0.845,-0.066 -1.265,-0.11 l -0.041,-0.003 c -0.115,-0.002 -0.229,-0.003 -0.344,-0.003 -4.017,0 -7.478,1.233 -10.292,3.668 -2.288,1.981 -3.214,4.74 -3.711,6.644 -0.631,2.416 -0.417,4.804 -0.091,7.024 0.806,5.508 1.861,10.489 3.225,15.229 0.042,0.144 0.046,0.159 -0.185,0.394 -4.025,4.095 -5.565,9.837 -4.119,15.361 1.444,5.517 5.592,9.764 11.096,11.359 4.479,1.296 9.29,0.581 13.2,-1.967 3.908,-2.547 6.506,-6.661 7.128,-11.286 0.13,-0.969 0.156,-1.909 0.129,-2.835 0.468,0.452 0.968,0.885 1.517,1.287 2.303,1.685 4.992,2.614 7.572,2.614 0.811,-0.001 1.589,-0.091 2.328,-0.269 l 3.088,1.815 c 3.868,2.274 7.415,5.058 10.542,8.275 l 0.646,0.665 0.176,0.181 0.204,0.149 C -7.64,5.9 -6.532,6.262 -5.372,6.262 -3.641,6.262 -2,5.431 -0.982,4.04 -0.126,2.871 0.222,1.436 0,0 m -16.543,23.025 c -22.921,12.637 -51.748,4.3 -64.385,-18.621 -12.638,-22.922 -4.301,-51.749 18.621,-64.386 22.921,-12.638 51.748,-4.301 64.386,18.621 12.637,22.922 4.3,51.748 -18.622,64.386",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(83.3685,66.4165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -0.077,-0.499 -0.338,-0.938 -0.734,-1.241 L -1.512,-1.63 c -4.301,-2.15 -8.295,-4.871 -11.872,-8.086 l -3.669,-3.299 -0.195,-0.174 0.033,-0.26 c 0.306,-2.445 -1.177,-5.255 -3.78,-7.159 -1.71,-1.252 -3.667,-1.941 -5.512,-1.941 -1.786,0 -3.247,0.651 -4.112,1.833 -1.823,2.491 -0.471,6.592 3.013,9.142 1.708,1.25 3.663,1.938 5.506,1.938 0.912,0 1.74,-0.169 2.462,-0.502 l 0.237,-0.109 0.225,0.133 4.265,2.507 c 4.138,2.432 7.933,5.411 11.279,8.853 l 0.615,0.633 c 0.324,0.227 0.705,0.347 1.104,0.347 0.619,0 1.204,-0.295 1.565,-0.789 C -0.044,1.023 0.079,0.512 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "translate(32.94,41.1045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -0.168,0.187 -0.247,0.21 -0.25,0.211 -1.872,0.605 -3.351,1.186 -4.751,1.983 -4.755,1.97 -4.759,1.956 -4.762,1.943 -5.894,-2.126 -6.773,-6.331 -7.451,-10.912 -7.708,-12.652 -8,-14.622 -7.61,-16.54 c 0.758,-3.733 2.619,-6.061 5.689,-7.12 3.553,-1.224 7.075,-1.196 10.466,0.085 2.891,1.091 4.66,3.135 5.256,6.075 0.03,0.145 -0.012,0.376 -0.085,0.478 C 9.499,-11.172 4.884,-5.444 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30",
    transform: "translate(38.034,41.0817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 8.764,-10.745 C 8.131,-6.425 7.252,-2.231 6.093,2.009 4.173,0.922 2.167,0.261 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34",
    transform: "translate(43.7776,66.6203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.787,0.671 -3.186,2.724 -8.403,2.507 -3.162,-0.124 -6.262,-1.747 -8.505,-4.452 -2.328,-2.807 -3.383,-6.312 -2.893,-9.616 0.472,-3.189 2.197,-6.022 4.856,-7.975 2.645,-1.943 5.847,-2.737 9.011,-2.237 5.231,0.826 8.724,3.903 10.102,8.9 C 5.549,-7.862 4.146,-3.53 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroToSolids);
export default __webpack_public_path__ + "static/media/intro_to_solids.e8e3e155183e9f9195b50ec49389b5f9.svg";
export { ForwardRef as ReactComponent };